import { render, staticRenderFns } from "./ContactDialog.vue?vue&type=template&id=ec328e4a&scoped=true"
import script from "./ContactDialog.vue?vue&type=script&lang=ts"
export * from "./ContactDialog.vue?vue&type=script&lang=ts"
import style0 from "./ContactDialog.vue?vue&type=style&index=0&id=ec328e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec328e4a",
  null
  
)

export default component.exports